<template>
  <div class="collect-page collect-card">
    <div class="mains-content">
      <div class="page-left">
        <div class="shop-head-serve br10">
          <div class="shop-head flex-row3 br10">
            <div class="shop-head-left">
              <div class="pb10">门店有效期</div>
              <div class="fontSize20">{{ shopEndTime }}</div>
              <div class="shopSms-style">
                <img src="../../../assets/images/new/shop-icon.png" alt="" />
              </div>
            </div>
            <div class="shop-head-left">
              <div class="pb10">短信余量(条)</div>
              <div class="fontSize20">{{ smsList || 0 }}</div>
              <div class="shopSms-style">
                <img src="../../../assets/images/new/sms-icon.png" alt="" />
              </div>
            </div>
            <div class="paymentRecord" @click="skipRecode">
              <img src="../../../assets/images/new/paymentRecords.png" alt="" />
            </div>
            <div class="paymentRecord" @click="skipRecode">
              <img src="../../../assets/images/new/paymentRecords.png" alt="" />
            </div>
          </div>
        </div>
        <div class="right-box">
          <div
            v-if="listSelected.length == 0 ? true : false"
            class="right-box-empty"
          >
            <div class="right-box-empty-img">
              <img src="../../../assets/images/new/fooBath_empty.png" alt="" />
            </div>
          </div>
          <div v-else>
            <p class="shoping-titles">消费明细</p>
            <div class="contents-body">
              <el-row class="tables-title">
                <el-col :span="8" class="titles"
                  ><div class="goodName">商品名称</div></el-col
                >
                <el-col :span="3" class="titles center">售价</el-col>
                <el-col :span="(active != 'sms' && discountFlag) ? 3 : 8" class="titles center"
                  >数量</el-col
                >
                <el-col :span="5" class="titles center" v-if="active != 'sms' && discountFlag"
                  >优惠</el-col
                >
                <el-col :span="3" class="titles center">小计</el-col>
                <el-col :span="2" class="titles right">操作</el-col>
              </el-row>
              <div class="tables p30">
                <div
                  class="boxs"
                  v-for="(item, index) in listSelected"
                  :key="index"
                >
                  <el-row class="right-content">
                    <el-col :span="8" class="titles "
                      ><div class="goodName fb">{{ item.name }}</div></el-col
                    >
                    <el-col :span="3" class="center fb">{{
                      item.salePrice
                    }}</el-col>
                    <el-col
                      :span="3"
                      class="nums center"
                      v-if="item.itemType != 'sms' && discountFlag"
                      >1</el-col
                    >
                    <el-col :span="8" class="nums center" v-else>
                      <span class="del-img" @click="blurItem('del', item)">
                        <img src="../../../assets/images/new/del.png" alt="" />
                      </span>
                      <el-input
                        v-model="item.num"
                        readonly
                        size="mini"
                        style="width: 40px;"
                      ></el-input>
                      <span class="del-img" @click="blurItem('add', item)">
                        <img src="../../../assets/images/new/add.png" alt="" />
                      </span>
                    </el-col>
                    <el-col
                      :span="5"
                      class="nums center"
                      v-if="item.itemType != 'sms' && discountFlag"
                    >
                      <span
                        class="moneys center fb fontSize18 faceValueStyle"
                        v-if="item.faceValue"
                        >{{ item.faceValue
                        }}<img
                          src="../../../assets/images/new/shopServeDel.png"
                          alt=""
                          class="shopServeDel cur"
                          @click="clearcoupon"
                      /></span>
                      <span class="cur" @click="useCoupons(item)" v-else
                        >使用优惠券</span
                      >
                    </el-col>
                    <el-col
                      :span="3"
                      class="titles center fb fontSize18"
                      v-if="item.itemType == 'shopManage' || item.itemType == 'packages'"
                      >{{
                        (item.faceValue
                          ? item.salePrice - item.faceValue
                          : item.salePrice
                        ).toFixed(2)
                      }}</el-col
                    >
                    <el-col
                      :span="3"
                      class="titles center fb fontSize18"
                      v-else
                      >{{ item.num * item.salePrice }}</el-col
                    >
                    <el-col :span="2" class="detail right"
                      ><i
                        class="el-icon-delete delete"
                        @click="deleteListSelected(item, index)"
                      ></i
                    ></el-col>
                  </el-row>
                </div>
              </div>
              <div class="confirm-btn">
                <div class="flex-row3 space-between">
                  <div class="msg">
                    <div class="nums total">
                      总数量:
                      <span>{{ totalNums }}</span>
                    </div>
                    <div class="total">
                      总金额:
                      <span class="moneys fontSize20" v-if="active == 'shopManage' || active == 'packages'"
                        >￥<span class="fontSize28 fb">{{
                          (listSelected[0].faceValue
                            ? listSelected[0].salePrice -
                              listSelected[0].faceValue
                            : listSelected[0].salePrice
                          ).toFixed(2)
                        }}</span></span
                      >
                      <span class="moneys fontSize20" v-else
                        >￥<span class="fontSize28 fb">{{
                          (
                            listSelected[0].salePrice * listSelected[0].num
                          ).toFixed(2)
                        }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-button class="save_btn" v-perm="{key:'shopServe', value: 'shopServe:buy'}" @click="saveMoney">确定订购</el-button>
    
      </div>
      <div class="left-box br10">
        <el-tabs v-model="active" @tab-click="handleClick">
          <el-tab-pane label="服务套餐" name="packages" v-if="flagForm.packageShowFlag == 'yes'"></el-tab-pane>
          <el-tab-pane label="门店服务" name="shopManage" v-if="flagForm.productShowFlag == 'yes'"></el-tab-pane>
          <el-tab-pane label="短信服务" name="sms" v-if="flagForm.productShowFlag == 'yes'"></el-tab-pane>
        </el-tabs>
        <div class="card-all scroll-auto" v-if="list && list.length != 0">
          <div class="title-tabs" v-show="active == 'packages'">
            <div class="card-serve-box" v-for="(item, index) in list" :key="index" @click="handleChangeList(item, index)">
              <div class=" card-msg">
                <template v-if="item.listingTimeType == 'custom' && item.showHms">
                  <div v-if="item.showHms">
                    <div class="flex-row mb10 blue f14">剩余<countdown :endTime="item.listingEndTime"></countdown></div>
                  </div>
                </template>
                <img
                  src="../../../assets/images/new/shopServe-active.png"
                  v-if="item.flag"
                  alt=""
                  class="card_active"
                />
                <div class="flex-row">
                  <div class="card-name flex1">{{ item.name }}</div>
                  <div>{{item.tag}}</div>
                </div>
                <div class="itemPrice"><span class="item_line">原价￥{{ item.originalPrice }}</span><span class="moneys">优惠价￥{{ item.salePrice }}</span></div>
                <div>套餐明细</div>
                <div class="flex-row">
                  
                  <div class="flex1 ml20">
                    <div v-for="(it,itx) in item.platformPackageItemList" :key="itx">
                      <el-row  class="mt10">
                        <el-col :span="10">{{it.itemName}} x1</el-col>
                        <el-col :span="6" class="center">
                          <span v-if="it.itemType == 'sms'">{{ it.smsNum }}条</span>
                          <span v-else-if="it.itemType == 'shopManage'">{{ it.duration == -1 ? '永久有效': it.duration}}{{ it.purchasePeriod == 'month' ? '个' : '' }}{{ it.purchasePeriodCn }}</span>
                          <span v-else>永久有效</span>
                          </el-col>
                        <el-col :span="8" class="right">
                          <div v-if="it.salePrice">
                            <span class="item_line">￥{{ it.salePrice }}</span>
                            <span class="moneys">￥{{ it.realPrice }}</span>
                          </div>
                          <span v-else class="moneys">￥{{ it.realPrice }}</span>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-for="it in item.platformPackageGiftItemList" :key="it.id">
                      <el-row  class="mt10">
                        <el-col :span="10">{{it.itemName}} x1</el-col>
                        <el-col :span="6" class="center">
                          <span v-if="it.itemType == 'sms'">{{ it.smsNum }}条</span>
                          <span v-else-if="it.itemType == 'shopManage'">{{ it.duration == -1 ? '永久有效': it.duration}}{{ it.purchasePeriod == 'month' ? '个' : '' }}{{ it.purchasePeriodCn }}</span>
                          <span v-else>永久有效</span>
                          <span class="gift-style">赠</span></el-col>
                        <el-col :span="8" class="right">
                          <div v-if="it.salePrice">
                            <span class="item_line">￥{{ it.salePrice }}</span>
                            <span class="moneys">￥{{ it.realPrice }}</span>
                          </div>
                          <span v-else class="moneys">￥{{ it.realPrice }}</span>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="title-tabs"  v-show="active == 'shopManage' || active == 'sms'">
            <div
              class="card-box"
              v-for="(item, index) in list"
              :key="index"
              :class="[active == 'sms' ? 'smsBackground' : '']"
            >
              <div @click="handleChangeList(item, index)">
                <div class="card-msg">
                  <div
                    class="flex-row3 space-between block"
                    v-if="item.listingTimeType == 'custom' && item.showHms"
                  >
                    <div v-if="item.showHms">
                      <div class="flex-row">剩余<countdown :endTime="item.listingEndTime"></countdown></div>
                    </div>
                    <p class="card-name">{{ item.tag }}</p>
                    <img
                      src="../../../assets/images/new/shopServe-active.png"
                      v-if="item.flag"
                      alt=""
                      class="card_active"
                    />
                  </div>
                  <div class="flex-row3 space-between block" v-if="item.listingTimeType != 'custom'">
                    <!-- <p class="card-name">{{ hmsStr }}</p> -->
                    <p class="card-name">{{ item.name || "门店服务1个月" }}</p>
                    <p class="card-name">{{ item.tag }}</p>
                    <img
                      src="../../../assets/images/new/shopServe-active.png"
                      v-if="item.flag"
                      alt=""
                      class="card_active"
                    />
                  </div>
                  <div v-if="item.listingTimeType == 'custom'" :class="{'mt10': item.showHms}">
                    <p class="card-name">{{ item.name || "门店服务1个月" }}</p>
                  </div>
                  <div
                    class="flex2-msg" style="text-decoration:line-through"
                    v-if="item.listingTimeType == 'custom'"
                  >
                    <span v-if="item.originalPrice || item.originalPrice == 0" style="text-decoration:line-through">原价¥{{ item.originalPrice }}</span>
                    <span v-else></span>
                  </div>
                  <div class="flex-msg" v-else>
                    <span v-if="item.originalPrice" style="text-decoration:line-through">原价¥{{ item.originalPrice }}</span>
                    <span v-else></span>
                  </div>
                  <div class="msg" v-if="active == 'shopManage'">
                    <span class="fontSize28" v-if="item.originalPrice || item.originalPrice == 0">优惠价¥{{ item.salePrice }}元/{{ item.duration }}{{ item.purchasePeriod == 'month' ? '个' : '' }}{{ item.purchasePeriodCn }}</span>
                    <span class="fontSize28" v-else>¥{{ item.salePrice }}元/{{ item.duration }}{{ item.purchasePeriod == 'month' ? '个' : '' }}{{ item.purchasePeriodCn }}</span>
                  </div>
                  <div class="msg" v-else>
                    <span class="fontSize28" v-if="item.originalPrice || item.originalPrice == 0">优惠价¥{{ item.salePrice }}元/{{ item.smsNum }}条</span>
                    <span class="fontSize28" v-else>¥{{ item.salePrice }}元/{{ item.smsNum }}条</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="card-all scroll-auto cardFlex"
          v-if="list && list.length == 0"
        >
          暂无数据
        </div>
      </div>
    </div>
    <coupon-dialogs ref="couponForm" @change="changeList"></coupon-dialogs>
    <wait-pay ref="waitPayForm" @change="onChange"></wait-pay>
    <pay ref="payForm" @change="backChange"></pay>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import waitPay from "./waitPay.vue";
import pay from "./pay.vue";
import couponDialogs from "./coupons.vue";
import countdown from '../../components/countDown.vue';
import { decrypt, encrypt } from "@/assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { couponDialogs, countdown, waitPay, pay },
  data() {
    return {
      list: [],
      listSelected: [],
      form: {
        faceValue: '',
        payWay: "",
        source: "pcCashier",
        name: '',
        salePrice: '',
        itemId: '',
        itemNum: '',
        couponCode: '',
        couponPwd: '',
        orderType: '',
        payPlatform: ''
      },
      active: "packages",
      shopEndTime: "",
      smsList: "",
      totalNums: 1,
      hmsStr: "",
      curStartTime: '2023-09-19 08:00:00',
      platformPayWay: 'wxpay',
      isFirstBuy: false,
      flagForm: {
        packageShowFlag: 'no',
        productShowFlag: 'no'
      },
      discountFlag: false,
    };
  },
  created() {
    console.log(this.$route);
    // if (!this.$route.query.type) {
    //   this.active = "packages"
    //   this.getPackageList()
    // }
    this.getshopLabel();
    this.getShopServe();
    this.getSmsServe();
    this.getConfig();
  },
  mounted() {},
  methods: {
    getConfig() { // 获取当前配置的支付方式
			this.$api.get(this.$url.shop.getConfig).then((res) => {
				if (res) {
          this.platformPayWay = res.platformPayWay == 'wxpay' ? 'weixin':'lakala';
				}
			})
    },
    async getshopLabel () {
      let res = await this.$api.get(this.$url.shopServe.purchaseInfo)
      if (res) {
        this.flagForm = res;
        if (res.packageShowFlag == 'yes') {
          this.active = "packages"
          this.getPackageList()
        } else if (res.productShowFlag == 'yes') {
          if (this.$route.query.type) {
            this.active = this.$route.query.type;
            if (this.$route.query.type == 'sms') {
              this.smsServeLists();
            } else {
              this.shopServeLists();
            }
          } else {
            this.active = "shopManage";
            this.shopServeLists();
          }
        }
      }
    },
    getShopServe() {
      this.$api.get(this.$url.shopServe.getShopPackageExpireDay).then((res) => {
        if (res) {
          this.shopEndTime = res;
        }
      });
    },
    getSmsServe() {
      this.$api.get(this.$url.shopServe.getSmsLeftNum).then((res) => {
        if (res) {
          this.smsList = res;
        }
      });
    },
    changeList(org) {
      if (org) {
        this.$set(this.listSelected[0], "faceValue", org.faceValue)
        this.form.couponCode = org.couponCode;
        this.form.couponPwd = org.activatCode;
      }
    },
    handleChangeList(item) {
      console.log(item);
      this.list.map((it) => {
        it.flag = false;
      });
      this.listSelected = [];
      item.flag = true;
      if (item.itemType == 'packages' && item.platformPackageItemList &&item.platformPackageItemList.length > 0) {
          let result = item.platformPackageItemList.find(y => y.itemType == 'shopManage')
          if (result) {
            this.discountFlag = true;
          } else {
            this.discountFlag = false;
          }
        } else if (item.itemType == 'shopManage') {
          this.discountFlag = true;
        }
      this.listSelected.push(JSON.parse(JSON.stringify(item)));
      if (item.itemType == "sms") {
        this.$set(this.listSelected[0], "num", 1);
      }
      this.totalNums = 1;
    },
    deleteListSelected(item, index) {
      this.list.map((it) => {
        it.flag = false;
      });
      this.listSelected.splice(index, 1);
      item.staffIds = [];
      this.totalNums = 1;
    },
    handleClick(item) {
      this.active = item.name;
      if (item.name == "sms") {
        this.smsServeLists();
      } else if (item.name == "shopManage") {
        this.shopServeLists();
      } else {
        this.getPackageList()
      }
      this.listSelected = [];
    },
    onChange(org) {
      if (org) {
        this.listSelected = [];
        this.form = {
          faceValue: '',
          payWay: "",
          source: "pcCashier",
          name: '',
          salePrice: '',
          itemId: '',
          itemNum: '',
          couponCode: '',
          couponPwd: '',
          orderType: '',
        };
        this.list.map((item) => {
          item.flag = false;
        });
        this.active = "shopManage";
        this.getShopServe();
        this.shopServeLists();
      }
		},
    saveMoney() {
      if (this.listSelected.length < 1) {
        this.$message.warning("请选择套餐");
        return false;
      }
      console.log(this.listSelected);
      this.form.name = this.listSelected[0].name;
      this.form.salePrice = this.listSelected[0].salePrice;
      this.form.itemId = this.listSelected[0].id;
      this.form.itemType = this.listSelected[0].itemType;
      this.form.itemNum = this.listSelected[0].num || 1;
      this.form.orderType = this.listSelected[0].itemType;
      this.form.faceValue = this.listSelected[0].faceValue || 0;
      this.form.payPlatform = this.platformPayWay;
      console.log(this.form);
      this.wxOrlkl()
    },
    wxOrlkl () {
      this.$api.post(this.$url.shopServe.createAllPackage, encrypt(JSON.stringify(this.form))).then((res) => {
        if (res) {
          let parmar = {
            url: res.payUrl,
            realPayAmount: res.realPayAmount,
            payStatus: res.payStatus,
            orderId: res.id,
            itemType: this.form.itemType,
            orderType: this.form.itemType,
            itemId: this.form.itemId,
            itemNum: this.form.itemNum,
            type: this.orderType
          };
          this.$refs["payForm"].$emit("set", parmar);
        }
      });
    },
    getPackageList () {
      this.list = []
      this.$api.post(this.$url.shopServe.listPackage, {status: 'enable'}).then((res) => {
        if (res) {
          this.listInit(res)
        }
      });
    },
    shopServeLists () {
      this.list = []
      this.$api.post(this.$url.shopServe.listShopPackage).then((res) => {
        if (res) {
          this.listInit(res)
        }
      });
    },
    smsServeLists() {
      this.list = []
      this.$api.post(this.$url.shopServe.listSmsPackage).then((res) => {
        if (res) {
          this.listInit(res)
        }
      });
    },
    listInit (res) {
      res.map((item, index) => {
        item.showHms = false;
        if (item.listingTimeType == "custom") {
          let currentTime = new Date().getTime();
          let changeTime = item.listingEndTime - currentTime;
          console.log('后台时间：',item.listingEndTime);
          console.log('当前时间：',currentTime);
          if (changeTime > 24 * 60 * 60 * 1000) {
            console.log('大于24小时');
            item.showHms = false;
          } else {
            console.log('小于24小时');
            item.showHms = true;
          }
        }
      });
      this.list = res;
    },
    useCoupons(item) {
      this.$refs["couponForm"].$emit("set", item);
    },
    clearcoupon() {
      this.form.couponCode = "";
      this.form.couponPwd = "";
      this.listSelected[0].faceValue = "";
    },
    blurItem(type, item) {
      if (type == "del" && item.num > 1) {
        item.num--;
        this.totalNums--;
      } else if (type == "add") {
        item.num++;
        this.totalNums++;
      }
    },
    skipRecode() {
      this.$router.push("/manage/paymentRecord");
    },
    backChange(org) {
      if (org) {
        this.listSelected = [];
        this.form = {
          source: "pcCashier",
        };
        this.list.map((item) => {
          item.flag = false;
        });
        if (this.active == "shopManage") {
          this.getShopServe();
        } else if (this.active == "sms") {
          this.getSmsServe();
        } else {
          this.getShopServe();
          this.getSmsServe();
        }
        this.getshopLabel();
      }
    },
    // 倒计时
    countTime(item) {
      // 获取当前时间
      let date = new Date();
      let now = date.getTime();
      // 设置截止时间
      let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
      // let end = item.listingEndTime;
      let end = endDate.getTime();
      // 时间差
      let leftTime = end - now;
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        // 时
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.hour = h < 10 ? "0" + h : h;
        // 分
        let m = Math.floor((leftTime / 1000 / 60) % 60);
        this.min = m < 10 ? "0" + m : m;
        // 秒
        let s = Math.floor((leftTime / 1000) % 60);
        this.second = s < 10 ? "0" + s : s;

        let str =
        this.day +
        "日" +
        this.hour +
        "时" +
        this.min +
        "分" +
        this.second +
        "秒";
        //将字符串显示在div中
        this.hmsStr = str;
      } else {
        this.day = 0;
        this.hour = "00";
        this.min = "00";
        this.second = "00";

        let str =
        this.day +
        "日" +
        this.hour +
        "时" +
        this.min +
        "分" +
        this.second +
        "秒";
        //将字符串显示在div中
        this.hmsStr = str;
      }
      // 等于0的时候不调用
      if (
        Number(this.hour) === 0 &&
        Number(this.day) === 0 &&
        Number(this.min) === 0 &&
        Number(this.second) === 0
      ) {
        return;
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        setTimeout(this.countTime, 1000);
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.block {
  width: 100%;
}
.card_active {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
  }
.cardFlex {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}
/deep/ .el-tabs__nav-wrap {
  padding: 0 16px;
  .el-tabs__item {
    height: 48px;
    line-height: 48px;
    font-size: 18px;
  }
}
/deep/ .el-dialog__header {
  border-bottom: 1px solid #f5f5f5;
}
.mains-content {
  display: flex;
  height: 100%;
  .left-box {
    width: 60%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    .tips-position {
      position: absolute;
      width: calc(100% - 74px);
      bottom: 16px;
    }
    .card-all {
      height: 100%;
      .title-tabs {
        display: flex;
        flex-wrap: wrap;
        padding: 0 16px 15px;
      }
    }
    .card-serve-box {
      width: calc(49% - 36px);
      padding: 16px;
      margin-right: 2%;
      margin-bottom: 20px;
      position: relative;
      border: 1px solid #666;
      border-radius: 5px;
      &:nth-of-type(2n) {
        margin-right: 0;
      }
    }
    .card-msg {
        .flex-msg {
          font-size: 14px;
          padding: 50px 0 0;
        }
        .flex2-msg {
          font-size: 14px;
          padding: 20px 0 0;
        }
        .lineView {
          position: relative;
          top: 10px;
          width: 30px;
          height: 1px;
          border-color: white;
        }
        .card-name {
          font-size: 18px;
          font-weight: 700;
        }
        .msg {
          text-align: left;
          position: absolute;
          bottom: 20px;
        }
        .itemPrice {
          padding: 10px 0;
          margin-bottom: 10px;
          border-bottom: 1px solid #666;
        }
      }
    .card-box {
      width: calc(49% - 32px);
      height: 132px;
      padding: 16px;
      margin-right: 2%;
      margin-bottom: 20px;
      background-image: url("../../../assets/images/new/shopServe.png");
      // background-position: center bottom;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      color: #fff;
      &:nth-of-type(2n) {
        margin-right: 0;
      }
      
      .active {
        color: #333;
        .money {
          color: @money;
        }
      }
    }
  }
}
.collect-card {
  height: calc(100vh - 58px);
  background-color: #e6edf5;
  padding: 16px;
  .groupDialog /deep/ .el-dialog__body {
    padding: 10px 20px;
    color: #111;
    height: 200px;
    overflow: auto;
  }
}
.right-box {
  background: url("../../../assets/images/new/footBath.png") no-repeat;
  background-size: 100% 100%;
  background-position: center bottom;
  height: calc(100vh - 288px);
  margin-right: 16px;
  .right-box-empty {
    height: calc(100vh - 248px);
    display: flex;
    justify-content: center;
    align-items: center;
    .right-box-empty-img {
      width: 191px;
      height: 170px;
    }
  }
  .shoping-titles {
    padding: 16px;
    font-size: 18px;
    font-weight: 700;
  }
  .contents-body {
    .tables-title {
      padding: 13px 16px;
      font-size: 14px;
      background: #f7f8fa;
    }
    .tables {
      padding: 0 0 16px;
      height: calc(100vh - 452px);
      box-sizing: border-box;
      .boxs {
        padding: 18px 16px 0;
        box-sizing: border-box;
        .money {
          color: @money;
          font-weight: 500;
        }
        .delete {
          font-size: 18px;
          cursor: pointer;
          &:hover {
            color: @blue;
          }
        }
      }
      .right-content {
        padding-bottom: 16px;
        border-bottom: 1px solid #ebedf0;
      }
    }
    .confirm-btn {
      display: flex;
      align-items: center;
      margin: 0 16px;
      border-top: 1px solid #ebedf0;
      padding: 12px 0;
      .flex-row3 {
        width: 100%;
        align-items: center;

        .msg {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          font-weight: 500;
          .nums {
            line-height: 3;
            margin-right: 40px;
          }
        }
      }
    }
  }
}
.page-left {
  width: 40%;
}
.box-actives {
  border: 1px solid #f9aa6c !important;
}
.save_btn {
  width: calc(100% - 16px);
  height: 68px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
  color: #fff;
  background: #ff5449;
}
.goodName {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.shop-head-serve {
  width: calc(100% - 48px);
  padding: 16px 16px 0 16px;
  background: white;
  border-radius: 10px 10px 0px 0px;
  .shop-head {
    position: relative;
    width: 100%;
    padding: 10px 0;
    font-size: 14px;
    color: white;
    background: linear-gradient(90deg, #3388ff 0%, #3388ff 100%);
  }
  .paymentRecord {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -19px;
    cursor: pointer;
  }
  .shop-head-left {
    width: 50%;
    margin-left: 30px;
    position: relative;
    .shopSms-style {
      position: absolute;
      top: -20px;
      right: 20px;
    }
  }
}
.smsBackground {
  background-image: url("../../../assets/images/new/smsServe.png") !important;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.shopServeDel {
  width: 8px;
  height: 8px;
  margin-left: 8px;
  vertical-align: middle;
}
.faceValueStyle {
  padding: 3px 10px;
  background: #fff6f6;
  border: 1px solid #f4f4f4;
  border-radius: 6px;
}
.nums {
  display: flex;
  justify-content: center;
  .del-img {
    width: 28px;
    height: 28px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border-radius: inherit;
    text-align: center;
    padding: 0;
    border-left: none;
    border-right: none;
  }
}
.gift-style {
  border-radius: 2px;
  padding: 2px;
  color: white;
  background-color: #257FFA;
  margin-left: 8px;
}
</style>
